import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import tooltip from 'angular-ui-bootstrap/src/tooltip';

import FieldInstanceService from '../../service/FieldInstanceService';
import FieldTypeService from '../../service/FieldTypeService';

// Component
import fieldInstanceComponent from './recapResponseFieldInstance.component';

// Dependencies
import '../../service';
import serviceModule from '../../service/module';
import fieldsModule from '../fields/module';
import errorMessageModule from '../errorMessage';

let module = angular.module('recaps.components.recapResponseFieldInstance', [
  'ng',
  tooltip,
  ngSanitize,
  serviceModule.name,
  fieldsModule.name,
  errorMessageModule.name,
]);

module.component('recapResponseFieldInstance', fieldInstanceComponent);

export default module;
